import { createEnvelopeSource } from './create-envelope-source';
import { DOC31_EDITION_ID } from './doc31-edition';

/**
 * Door openings of one 31DOC edition (`GET /analytics/door-openings-31doc`),
 * the 31DOC play. `openingsPerPlayer31doc` is a ratio, so a period with no
 * player reads unavailable rather than "0 each".
 */
export const doorOpenings31docSource = createEnvelopeSource({
    label: '31DOC door openings',
    endpoint: 'analytics/door-openings-31doc',
    metrics: [
        { id: 'doorsOpened31doc', label: 'Doors opened', type: 'scalar' },
        {
            id: 'doorPlayers31doc',
            label: 'Players who opened a door',
            type: 'scalar',
        },
        {
            id: 'openingsPerPlayer31doc',
            label: 'Openings per player',
            type: 'ratio',
        },
    ],
    forms: ['number'],
    regionGrain: 'province',
    staticParams: { campaignId: DOC31_EDITION_ID },
});
